var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { ExportarExcel, ExportarPDF } from '../../utils';
export var BotoesExportacao = function (_a) {
    var estadoBusca = _a.estadoBusca, acoesPermitidas = _a.acoesPermitidas, gerarPDF = _a.gerarPDF, gerarExcel = _a.gerarExcel, _b = _a.nomeArquivo, nomeArquivo = _b === void 0 ? 'relatorio' : _b;
    var _c = estadoBusca || {}, textoBusca = _c.textoBusca, status = _c.status, instituicao = _c.instituicao, dataInicio = _c.dataInicio, dataFim = _c.dataFim;
    var extrairFiltros = function () { return [
        textoBusca === '' ? null : textoBusca,
        status === '-1' ? null : status,
        instituicao === -1 ? null : instituicao === null || instituicao === void 0 ? void 0 : instituicao.toString(),
        dataInicio === '' ? null : dataInicio,
        dataFim === '' ? null : dataFim,
    ]; };
    var baixarArquivo = function (blobUrl, extensao) {
        try {
            var link = document.createElement('a');
            link.href = blobUrl;
            link.download = "".concat(nomeArquivo, ".").concat(extensao);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(blobUrl);
        }
        catch (error) {
            console.error("Erro ao baixar arquivo .".concat(extensao, ":"), error);
        }
    };
    var handleExportarPDF = function () { return __awaiter(void 0, void 0, void 0, function () {
        var doc;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!gerarPDF)
                        return [2 /*return*/];
                    return [4 /*yield*/, gerarPDF.apply(void 0, extrairFiltros())];
                case 1:
                    doc = _a.sent();
                    if (doc) {
                        baixarArquivo(doc, 'pdf');
                    }
                    else {
                        alert('Erro ao gerar o arquivo PDF');
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    var handleExportarExcel = function () { return __awaiter(void 0, void 0, void 0, function () {
        var doc;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!gerarExcel)
                        return [2 /*return*/];
                    return [4 /*yield*/, gerarExcel.apply(void 0, extrairFiltros())];
                case 1:
                    doc = _a.sent();
                    if (doc) {
                        baixarArquivo(doc, 'xls');
                    }
                    else {
                        alert('Erro ao gerar o arquivo Excel');
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    return (_jsxs(_Fragment, { children: [(acoesPermitidas === null || acoesPermitidas === void 0 ? void 0 : acoesPermitidas['EXPORTAR PDF']) && gerarPDF && _jsx(ExportarPDF, { onClick: handleExportarPDF }), (acoesPermitidas === null || acoesPermitidas === void 0 ? void 0 : acoesPermitidas['EXPORTAR EXCEL']) && gerarExcel && _jsx(ExportarExcel, { onClick: handleExportarExcel })] }));
};
export default BotoesExportacao;
